
   
function getDate(initialDate, days, weekendsDelivery) {
  const date = new Date(initialDate);
  for (let i = 0; i < days; i++) {
      date.setDate(date.getDate() + 1)
      const dayOfWeek = date.getDay();
      if(!weekendsDelivery){
          if(dayOfWeek == 0 || dayOfWeek == 6) {
              days++;
          }
      }
  }
  return days;
}


  let minD =window.liquid.minDias;alert(minD);
  let maxD = window.liquid.maxDias;
  let aceptaweekend = window.liquid.aceptaFin;
const fecha = new Date();
const fechaMin = getDate(fecha, minD, aceptaweekend);
const fechaMax = getDate(fecha, maxD, aceptaweekend);


window.onload = function() {

  if (window.jQuery) {
   
      let $ = window.jQuery;
      if  (aceptaweekend){finde = ''} else {finde = $.datepicker.noWeekends}
      $(function() {
        $("#date").datepicker({
         minDate: +fechaMin,
         maxDate: +fechaMax,
         beforeShowDay: finde
      });
    });
  }
}
